import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  accountType: null, // 1
  advertisementName: null, // "test nickname"
  address: null, // ""
  businessName: null, // ""
  cel: null, // "348 123456"
  cel2: null, // ""
  city: null, // "Bergamo Alta"
  civic: null, // "5"
  codiceFiscale: null, // "blljcp"
  displayEmail: null, // ""
  country: null, // "italia"
  credits: null, // 0
  facebook: null, // ""
  email: null, // "admin"
  hasAdvertisements: null, // true
  instagram: null, // ""
  id: null, // 16
  isAdmin: null, // true
  lastName: null, // "Bellocchio"
  name: null, // "Jacopo"
  partitaIva: null, // ""
  codiceDestinazione: null, // ""
  province: null, // "BG"
  street: null, // "via del sottoscritto"
  tel: null, // "123123"
  token: null, // "OykftCswoFguXatwWPYDxkhfPHAjUArSDGuGDv9M3MFBc/KdRZGlJLTIyqVRAsYE7+UCGUjK2epSQSXmFkB+/g=="
  website: null, // ""
  zipCode: null, // "20100"
  // Client only
  isLogged: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState: INITIAL_STATE,
  reducers: {
    login: (state, action) => ({
      ...action.payload,
      isLogged: true,
    }),
    refreshData: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    logout: () => INITIAL_STATE,
  },
});

export const { login, logout, refreshData } = userSlice.actions;

export const selectUser = (state) => state.user;

export default userSlice.reducer;
